import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function formatRut(rut: string): string {
  const digitoVerificador = rut.slice(-1).toUpperCase();
  const dniNums = rut.slice(0, -1).replace(/\D/g, "");
  const rutInvertido = dniNums.split("").reverse().join("");
  let rutConPuntos = "";
  for (let i = 0; i < rutInvertido.length; i += 3) {
    rutConPuntos += rutInvertido.slice(i, i + 3) + ".";
  }
  rutConPuntos = rutConPuntos.slice(0, -1).split("").reverse().join("");

  return `${rutConPuntos}-${digitoVerificador}`;
}

// RUT para la API: sin puntos ni espacios y con guion antes del digito verificador (76842252-4).
export function normalizeDniWithDash(dni: string): string {
  const clean = dni.replace(/[.\s]/g, "").toUpperCase();
  if (clean.includes("-") || clean.length < 2) return clean;
  return `${clean.slice(0, -1)}-${clean.slice(-1)}`;
}

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(control.value as string);
    return valid ? null : { invalidEmail: true };
  };
}

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phoneRegex = /^\+(54|55|56|57|58|59|51|52|53|591|592|593|595|597|598|599) ?\d{8,10}$/;
    const valid = phoneRegex.test(control.value as string);
    return valid ? null : { invalidPhoneNumber: true };
  };
}

export function nameValidator(requireMultipleWords = true): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const nameRegex = requireMultipleWords ? /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(?:\s+[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)+$/ : /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(?:\s+[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;
    const valid = nameRegex.test(control.value as string);
    return valid ? null : { invalidName: true };
  };
}
